import React from "react";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import "./modal.css";

const Rendermodals = (props) => {
  const closeBtn = (
    <button className="close" onClick={props.handleModalClose}>
      &times;
    </button>
  );
  return (
    <Modal
      isOpen={props.assessmentModal}
      centered={true}
      className="submitModal"
    >
      <ModalHeader close={closeBtn}>{props.modalHeading}</ModalHeader>
      <ModalBody>
        <div className="modal-inner-content"></div>
        <div>{props.children}</div>
      </ModalBody>
    </Modal>
  );
};

export default Rendermodals;



// WEBPACK FOOTER //
// ./src/new/Components/Modals/modal.jsx